















import Vue from 'vue'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { fetchAllGenres } from '@/api/genre'

import { fetchTrendingBeats, TrendingFilter, TrendingPeriod } from '@/api/beats'
import { BeatFilterType, fetchBeats } from '~/api/beats'

@Component
export default class TrendingFilterList extends Vue {
    @Prop({ type: Boolean }) inTrendingPage: boolean

    activeTrendingFilterIndex = 0
    isDropdownOpen = false
    genres: IGenre[] = []

    get filtersArray(): TrendingFilter[] {
        const thisWeekFilter: TrendingFilter = { name: 'This Week', period: TrendingPeriod.Week, genreId: null }
        const genreFilters = this.genres.map(it => ({
            name: it.name,
            period: TrendingPeriod.AllTime,
            genreId: it.id
        }))
        const filters: TrendingFilter[] = []
        filters.push(thisWeekFilter)
        filters.push(...genreFilters)
        return filters
    }

    closeDropdown() {
        this.isDropdownOpen = false
    }

    async changeTrendingFilter(index: number) {
        this.activeTrendingFilterIndex = index
        const trendingFilter = this.filtersArray[index]
        // make call in parent
        let limit = 10
        if (!trendingFilter.genreId) limit = 100
        this.$emit('changeTrendingFilter', limit, trendingFilter.period, trendingFilter.genreId)
        this.closeDropdown()
    }

    async mounted() {
        this.genres = await fetchAllGenres()
    }
}
